exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#footer{\n    position: relative;\n    float: left;\n    width: 100%;\n\n}\n\n#footerContainer{\n    position: relative;\n    float: left;\n\tdisplay: flex;\n    width: 100%;\n    justify-content: center;\n\tmargin: 0 0 0 0; \n\t\n\tfont-family: \"Myriad Pro\",Helvetica,Arial,sans-serif;\n    font-size: 13px;\n    color: #777879;\n    line-height: 18px;\n\n}\n\n#footerLogo{\n    position: relative;\n    float: left; \n\twidth: 70px;\n    height: 70px;\n\t\n    flex-grow: 1;\n    text-align: center;\n    font-size: 18px;\n\t\n\tbackground-image: url(" + require("../assets/image/Logo/LogoGF.png") + ");\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: contain;\n\t\n}\n\n#footerAdress{\n\t\n    position: relative;\n    float: left; \n\t\n    flex-grow: 2;\n    text-align: left;\n\n\t\t\n}\n\n#legalInfo{\n\t\n    position: relative;\n    float: left; \n\t\n    flex-grow: 2;\n    text-align: left;\n\n\t\t\n}\n#copyright{\n\t\n    position: relative;\n    float: left; \n\t\n    flex-grow: 2;\n    text-align: right;\n\n\t\t\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/css/footer.css
// module id = 80
// module chunks = 0